// Grid dimensions
export const GRID_COLS = 21;
export const GRID_ROWS = 27;
export const TILE_SIZE = 64;

// Cell types
export const CELL = { CORRIDOR: 0, WALL: 1, HUB: 2, POWERUP: 3, TUNNEL: 4 };

// Spawn positions
export const PLAYER_SPAWN = { col: 10, row: 21 };
export const HUB_EXIT = { col: 10, row: 12 };

// Hub bounds
export const HUB = { colStart: 8, colEnd: 12, rowStart: 13, rowEnd: 15 };

// Fixed power-up positions
export const POWERUP_POS = [[1, 1], [19, 1], [1, 25], [19, 25]];

// Tunnel row
export const TUNNEL_ROW = 14;

// Bonus pallet config
export const BONUS = { col: 10, row: 8, interval: 20, duration: 8, points: 500 };

// Difficulty tiers — speed multiplier + frightened duration
export const DIFFICULTY = [
  { from: 0, to: 30, speedMul: 0.80, frightenedSec: 8 },
  { from: 30, to: 60, speedMul: 0.90, frightenedSec: 6 },
  { from: 60, to: 90, speedMul: 1.00, frightenedSec: 4 },
];

// Chase/Scatter phase durations (seconds) — classic Pac-Man timing
// Each pair = [scatter, chase]; last chase phase lasts forever
export const PHASE_TIMINGS = [
  { scatter: 4, chase: 20 },
  { scatter: 4, chase: 20 },
  { scatter: 3, chase: 20 },
  { scatter: 3, chase: Infinity },
];

// Ghost modes
export const GHOST_MODE = { SCATTER: 'scatter', CHASE: 'chase', FRIGHTENED: 'frightened', EATEN: 'eaten' };

// Scatter targets (corners)
export const SCATTER = {
  blinky: { col: 19, row: 1 },
  pinky: { col: 1, row: 1 },
  inky: { col: 19, row: 25 },
  clyde: { col: 1, row: 25 },
};

// Enemy release delay (seconds)
export const ENEMY_RELEASE = { blinky: 0, pinky: 3, inky: 6, clyde: 9 };
export const ENEMY_TYPES = ['blinky', 'pinky', 'inky', 'clyde'];
export const ENEMY_HUB_POS = [
  { col: 10, row: 13 },
  { col: 9, row: 14 },
  { col: 11, row: 14 },
  { col: 10, row: 14 },
];

// All sprite definitions for admin panel
export const SPRITES = {
  player: [
    { id: 'truck_normal', name: 'Camioncino', dims: '192×96', desc: 'Vista laterale, sfondo trasparente' },
    { id: 'truck_powered', name: 'Camioncino Potenziato', dims: '240×120', desc: 'Opzionale — se assente usa truck_normal con tint blu' },
  ],
  enemies: [
    { id: 'enemy_blinky', name: 'Blinky (ZTL)', dims: '80×80', desc: 'Nemico Rosso — Segnale ZTL' },
    { id: 'enemy_pinky', name: 'Pinky (Maltempo)', dims: '80×80', desc: 'Nemico Rosa — Segnale Maltempo' },
    { id: 'enemy_inky', name: 'Inky (Lavori)', dims: '80×80', desc: 'Nemico Blu — Segnale Lavori in Corso' },
    { id: 'enemy_clyde', name: 'Clyde (Dogana)', dims: '80×80', desc: 'Nemico Arancione — Segnale Dogana' },
    { id: 'enemy_scared', name: 'Nemico Spaventato', dims: '80×80', desc: 'Condiviso da tutti' },
    { id: 'enemy_scared_blink', name: 'Nemico Scadenza', dims: '80×80', desc: 'Opzionale — alterna scared/normal' },
  ],
  collectibles: [
    { id: 'pill_small', name: 'Pillola Piccola', dims: '16×16', desc: '10 punti — sulle strade' },
    { id: 'bonus_pallet', name: "Pallet d'Oro", dims: '64×64', desc: '500 punti — appare ogni 20s' },
    { id: 'powerup_logo', name: 'Power-up Palletways', dims: '80×80', desc: 'Angoli mappa — attiva fuga nemici' },
  ],
  road_tiles: [
    { id: 'tile_road', name: 'Strada Base', dims: '96×96', desc: 'Cella isolata / fallback' },
    { id: 'tile_road_h', name: 'Strada Orizzontale', dims: '96×96', desc: 'Con mezzeria' },
    { id: 'tile_road_v', name: 'Strada Verticale', dims: '96×96', desc: 'Con mezzeria' },
    { id: 'tile_road_cross', name: 'Incrocio 4 Vie', dims: '96×96', desc: 'Tutte le direzioni' },
    { id: 'tile_road_t_n', name: 'T Nord', dims: '96×96', desc: 'Uscite N/E/O' },
    { id: 'tile_road_t_s', name: 'T Sud', dims: '96×96', desc: 'Uscite S/E/O' },
    { id: 'tile_road_t_e', name: 'T Est', dims: '96×96', desc: 'Uscite N/S/E' },
    { id: 'tile_road_t_o', name: 'T Ovest', dims: '96×96', desc: 'Uscite N/S/O' },
    { id: 'tile_road_ne', name: 'Curva NE', dims: '96×96', desc: 'Nord-Est' },
    { id: 'tile_road_nw', name: 'Curva NO', dims: '96×96', desc: 'Nord-Ovest' },
    { id: 'tile_road_se', name: 'Curva SE', dims: '96×96', desc: 'Sud-Est' },
    { id: 'tile_road_sw', name: 'Curva SO', dims: '96×96', desc: 'Sud-Ovest' },
  ],
  wall_tiles: [
    { id: 'tile_wall', name: 'Muro Interno', dims: '96×96', desc: 'Nessun lato su strada' },
    { id: 'tile_wall_n', name: 'Muro Nord', dims: '96×96', desc: 'Strada a nord' },
    { id: 'tile_wall_s', name: 'Muro Sud', dims: '96×96', desc: 'Strada a sud' },
    { id: 'tile_wall_e', name: 'Muro Est', dims: '96×96', desc: 'Strada a est' },
    { id: 'tile_wall_o', name: 'Muro Ovest', dims: '96×96', desc: 'Strada a ovest' },
    { id: 'tile_wall_ne', name: 'Angolo NE', dims: '96×96', desc: 'Strade a nord e est' },
    { id: 'tile_wall_nw', name: 'Angolo NO', dims: '96×96', desc: 'Strade a nord e ovest' },
    { id: 'tile_wall_se', name: 'Angolo SE', dims: '96×96', desc: 'Strade a sud e est' },
    { id: 'tile_wall_sw', name: 'Angolo SO', dims: '96×96', desc: 'Strade a sud e ovest' },
  ],
  special_tiles: [
    { id: 'tile_hub', name: 'Hub Palletways', dims: '480×288', desc: 'Zona centrale 5x3 celle' },
    { id: 'tile_tunnel_l', name: 'Tunnel Sinistra', dims: '96×96', desc: 'Uscita warp sinistra' },
    { id: 'tile_tunnel_r', name: 'Tunnel Destra', dims: '96×96', desc: 'Uscita warp destra' },
  ],
  ui: [
    { id: 'logo_header', name: 'Logo Header', dims: '480×128', desc: 'Logo Palletways — header app' },
    { id: 'logo_hub', name: 'Logo Hub', dims: '256×128', desc: 'Logo Palletways — dentro hub' },
  ],
};

// Flat list of all sprite IDs (for loading)
export const ALL_SPRITE_IDS = Object.values(SPRITES).flat().map(s => s.id);

// Fallback map (0=corridor 1=wall 2=hub 3=power-up 4=tunnel)
// Classic Pac-Man style: 1-tile corridors, large wall blocks, no dead ends
export const FALLBACK_MAP = [
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3,1],
  [1,0,1,1,1,0,1,1,1,0,1,0,1,1,1,0,1,1,1,0,1],
  [1,0,1,1,1,0,1,1,1,0,1,0,1,1,1,0,1,1,1,0,1],
  [1,0,1,1,1,0,1,1,1,0,1,0,1,1,1,0,1,1,1,0,1],
  [1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1],
  [1,0,1,1,1,0,1,0,1,1,1,1,1,0,1,0,1,1,1,0,1],
  [1,0,1,1,1,0,1,0,1,1,1,1,1,0,1,0,1,1,1,0,1],
  [1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1],
  [1,1,1,1,1,0,1,1,1,0,1,0,1,1,1,0,1,1,1,1,1],
  [1,1,1,1,1,0,1,1,1,0,1,0,1,1,1,0,1,1,1,1,1],
  [1,1,1,1,1,0,1,1,1,0,1,0,1,1,1,0,1,1,1,1,1],
  [1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1],
  [1,1,1,1,1,0,1,0,1,2,2,2,1,0,1,0,1,1,1,1,1],
  [4,0,0,0,0,0,1,0,2,2,2,2,2,0,1,0,0,0,0,0,4],
  [1,1,1,1,1,0,1,0,2,2,2,2,2,0,1,0,1,1,1,1,1],
  [1,1,1,1,1,0,1,0,1,1,1,1,1,0,1,0,1,1,1,1,1],
  [1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1],
  [1,1,1,1,1,0,1,1,1,0,1,0,1,1,1,0,1,1,1,1,1],
  [1,1,1,1,1,0,1,1,1,0,1,0,1,1,1,0,1,1,1,1,1],
  [1,1,1,1,1,0,1,1,1,0,1,0,1,1,1,0,1,1,1,1,1],
  [1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1],
  [1,0,1,1,1,0,1,0,1,1,1,1,1,0,1,0,1,1,1,0,1],
  [1,0,1,1,1,0,1,0,1,1,1,1,1,0,1,0,1,1,1,0,1],
  [1,0,1,1,1,0,1,0,1,1,1,1,1,0,1,0,1,1,1,0,1],
  [1,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
];
